// Interfaz de los textos por ruta
export interface RouteTextTemplate {
  title: string;
  text: string;
  tab: string;
}

export interface RouteTextKeyTemplate {
  titleKey: string;
  textKey: string;
  tabKey: string;
}

// Estructura general de llaves de traduccion por ruta
export const ROUTE_TEXT_KEYS_BY_ROUTE: Record<string, RouteTextKeyTemplate> = {
  '/accounts': { titleKey: 'routeText.accounts.title', textKey: 'routeText.accounts.text', tabKey: 'routeText.accounts.tab' },
  '/add': { titleKey: 'routeText.add.title', textKey: 'routeText.add.text', tabKey: 'routeText.add.tab' },
  '/login': { titleKey: 'routeText.login.title', textKey: 'routeText.login.text', tabKey: 'routeText.login.tab' },
  '/logout': { titleKey: 'routeText.logout.title', textKey: 'routeText.logout.text', tabKey: 'routeText.logout.tab' },
  '/signup': { titleKey: 'routeText.signup.title', textKey: 'routeText.signup.text', tabKey: 'routeText.signup.tab' },
  '/continue': { titleKey: 'routeText.continue.title', textKey: 'routeText.continue.text', tabKey: 'routeText.continue.tab' },
  '/confirm': { titleKey: 'routeText.confirm.title', textKey: 'routeText.confirm.text', tabKey: 'routeText.confirm.tab' },
  '/account-recovery': {
    titleKey: 'routeText.accountRecovery.title',
    textKey: 'routeText.accountRecovery.text',
    tabKey: 'routeText.accountRecovery.tab'
  },
  '/confirm-recovery': {
    titleKey: 'routeText.confirmRecovery.title',
    textKey: 'routeText.confirmRecovery.text',
    tabKey: 'routeText.confirmRecovery.tab'
  },
  '/resend-code': {
    titleKey: 'routeText.resendCode.title',
    textKey: 'routeText.resendCode.text',
    tabKey: 'routeText.resendCode.tab'
  },
  '/reset-password': {
    titleKey: 'routeText.resetPassword.title',
    textKey: 'routeText.resetPassword.text',
    tabKey: 'routeText.resetPassword.tab'
  },
  '/update_account': {
    titleKey: 'routeText.updateAccount.title',
    textKey: 'routeText.updateAccount.text',
    tabKey: 'routeText.updateAccount.tab'
  },
};

export const DEFAULT_ROUTE_TEXT_KEYS: RouteTextKeyTemplate = {
  titleKey: 'routeText.notFound.title',
  textKey: 'routeText.notFound.text',
  tabKey: 'routeText.notFound.tab',
};

export function getRouteTextKeys(route: string): RouteTextKeyTemplate {
  return ROUTE_TEXT_KEYS_BY_ROUTE[route] || DEFAULT_ROUTE_TEXT_KEYS;
}
